// extracted by mini-css-extract-plugin
module.exports = {"onboarding":"styles_onboarding__PMUlD"};